import { render, staticRenderFns } from "./CompanyProfileComponent.vue?vue&type=template&id=b80746a4&"
import script from "./CompanyProfileComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports